<script setup lang="ts">
import { computed } from 'vue'

// Tree-shakeable imports - only these 14 flags will be bundled
import BG from 'country-flag-icons/string/3x2/BG'
import CZ from 'country-flag-icons/string/3x2/CZ'
import DE from 'country-flag-icons/string/3x2/DE'
import ES from 'country-flag-icons/string/3x2/ES'
import FR from 'country-flag-icons/string/3x2/FR'
import GB from 'country-flag-icons/string/3x2/GB'
import HR from 'country-flag-icons/string/3x2/HR'
import HU from 'country-flag-icons/string/3x2/HU'
import IT from 'country-flag-icons/string/3x2/IT'
import NL from 'country-flag-icons/string/3x2/NL'
import PL from 'country-flag-icons/string/3x2/PL'
import RO from 'country-flag-icons/string/3x2/RO'
import SI from 'country-flag-icons/string/3x2/SI'
import SK from 'country-flag-icons/string/3x2/SK'

interface Props {
  code: string
  class?: string
}

const props = withDefaults(defineProps<Props>(), {
  class: ''
})

const flagMap: Record<string, string> = {
  bg: BG,
  cz: CZ,
  de: DE,
  es: ES,
  fr: FR,
  gb: GB,
  hr: HR,
  hu: HU,
  it: IT,
  nl: NL,
  pl: PL,
  ro: RO,
  si: SI,
  sk: SK
}

const flagSvg = computed(() => {
  const code = props.code.toLowerCase()
  return flagMap[code] || ''
})
</script>

<template>
  <!-- Safe to use v-html here: SVG content comes from trusted package imports, not user input -->
  <!-- eslint-disable vue/no-v-html -->
  <span
    v-if="flagSvg"
    :class="props.class"
    v-html="flagSvg"
  />
  <!-- eslint-enable vue/no-v-html -->
</template>
